(function () {
  'use strict';

  /* Scent families → keywords used in custom.duftfamilie */
  var FAMILIES = {
    fresh:    { label: 'Frisch & Zitrisch',   words: ['frisch', 'zitrus', 'grün', 'gruen', 'aquatisch', 'bergamotte', 'grapefruit', 'orange', 'ingwer'],
                text: 'Klar, spritzig und belebend: Zitrusfrüchte, grüne Noten und ein Hauch Meer. Perfekt für alle, die es leicht und sauber mögen.' },
    floral:   { label: 'Blumig & Pudrig',     words: ['blumig', 'pudrig', 'chypre'],
                text: 'Weich, elegant und feminin: Rose, Jasmin, Iris und pudrige Akkorde, die den ganzen Tag schmeicheln.' },
    sweet:    { label: 'Süß & Gourmand',      words: ['süß', 'suess', 'gourmand', 'cremig'],
                text: 'Verführerisch und warm: Vanille, Karamell, Tonka und cremige Noten, die süchtig machen.' },
    fruity:   { label: 'Fruchtig',            words: ['fruchtig'],
                text: 'Saftig und fröhlich: Beeren, Pfirsich, Apfel und exotische Früchte mit viel guter Laune.' },
    woody:    { label: 'Holzig & Würzig',     words: ['holzig', 'würzig', 'wuerzig', 'ledrig', 'rauchig', 'erdig', 'fougère', 'fougere'],
                text: 'Charakterstark und modern: Zedernholz, Vetiver, Pfeffer und Leder für einen Auftritt mit Tiefe.' },
    oriental: { label: 'Orientalisch & Warm', words: ['orientalisch', 'harzig', 'animalisch', 'amber', 'oud'],
                text: 'Opulent und sinnlich: Oud, Amber, Harze und Gewürze, die lange auf der Haut bleiben.' }
  };
  var OCCASIONS = {
    daily:   { label: 'Alltag & Büro',      words: ['täglich', 'alltäglich', 'arbeit'] },
    leisure: { label: 'Freizeit & Sport',   words: ['freizeit', 'sport'] },
    evening: { label: 'Abends & Ausgehen',  words: ['abend', 'ausgehen', 'velentinstag', 'valentinstag'] },
    any:     { label: 'Zu jeder Gelegenheit', words: [] }
  };

  var QUESTIONS = [
    { id: 'gender', title: 'Für welche Duftwelt suchst du?', sub: 'Wir zeigen dir passende Düfte, Unisex-Düfte sind immer mit dabei.', type: 'single', options: [
      { v: 'female', l: 'Feminin', d: 'Damendüfte', sw: 'linear-gradient(140deg,#f6dcdc,#d9a3a8)' },
      { v: 'male', l: 'Maskulin', d: 'Herrendüfte', sw: 'linear-gradient(140deg,#4a4a4a,#111)' },
      { v: 'unisex', l: 'Unisex & Nische', d: 'Düfte für alle', sw: 'linear-gradient(140deg,#efe2c8,#c9a76a)' },
      { v: 'any', l: 'Ist mir egal', d: 'Überrasch mich', sw: 'linear-gradient(140deg,#e6e3df,#bdb7ae)' }
    ] },
    { id: 'fam', title: 'Welche Duftrichtungen magst du?', sub: 'Wähle bis zu drei.', type: 'multi', max: 3, options: [
      { v: 'fresh', l: 'Frisch & Zitrisch', d: 'Zitrone, Bergamotte, Meer', sw: 'linear-gradient(140deg,#e8f6f2,#8fd0c3)' },
      { v: 'floral', l: 'Blumig & Pudrig', d: 'Rose, Jasmin, Iris', sw: 'linear-gradient(140deg,#fbe4ec,#e6a0b8)' },
      { v: 'sweet', l: 'Süß & Gourmand', d: 'Vanille, Karamell, Tonka', sw: 'linear-gradient(140deg,#f7e7d3,#d6a26b)' },
      { v: 'fruity', l: 'Fruchtig', d: 'Beeren, Pfirsich, Apfel', sw: 'linear-gradient(140deg,#fde3dc,#f08a7a)' },
      { v: 'woody', l: 'Holzig & Würzig', d: 'Zeder, Vetiver, Pfeffer', sw: 'linear-gradient(140deg,#e9dfd2,#8d6f52)' },
      { v: 'oriental', l: 'Orientalisch & Warm', d: 'Oud, Amber, Gewürze', sw: 'linear-gradient(140deg,#efd9c4,#7d3f2b)' }
    ] },
    { id: 'occ', title: 'Wann trägst du deinen Duft am liebsten?', type: 'single', options: [
      { v: 'daily', l: 'Alltag & Büro', d: 'Dezent und angenehm' },
      { v: 'leisure', l: 'Freizeit & Sport', d: 'Leicht und unkompliziert' },
      { v: 'evening', l: 'Abends & Ausgehen', d: 'Mit Ausstrahlung' },
      { v: 'any', l: 'Zu jeder Gelegenheit', d: 'Ein Allrounder' }
    ] },
    { id: 'season', title: 'In welcher Jahreszeit vor allem?', type: 'single', options: [
      { v: 'Frühling', l: 'Frühling', d: 'Frisch und blühend' },
      { v: 'Sommer', l: 'Sommer', d: 'Leicht und luftig' },
      { v: 'Herbst', l: 'Herbst', d: 'Warm und gemütlich' },
      { v: 'Winter', l: 'Winter', d: 'Intensiv und wärmend' },
      { v: 'any', l: 'Ganzjährig', d: 'Passt immer' }
    ] },
    { id: 'budget', title: 'Wie viel möchtest du ausgeben?', sub: 'Gilt für die kleinste verfügbare Größe.', type: 'single', options: [
      { v: '0-5000', l: 'Bis 50 €', d: 'Smarte Lieblinge' },
      { v: '5000-10000', l: '50 bis 100 €', d: 'Designer-Klassiker' },
      { v: '10000-999999', l: 'Über 100 €', d: 'Nische & Luxus' },
      { v: 'any', l: 'Egal', d: 'Hauptsache, er passt' }
    ] }
  ];

  var fmt = function (c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var low = function (s) { return String(s || '').toLowerCase(); };

  function famsOf(p) {
    var tags = low(p.f).split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var res = {};
    Object.keys(FAMILIES).forEach(function (k) {
      var n = tags.filter(function (t) { return FAMILIES[k].words.some(function (w) { return t.indexOf(w) > -1; }); }).length;
      if (n) res[k] = n;
    });
    return res;
  }

  function score(p, a) {
    var g = low(p.g), why = [];
    if (g === 'damen' || g === 'frauen') g = 'female';
    if (g === 'herren' || g === 'männer') g = 'male';
    var gf = 1;
    if (a.gender === 'female') gf = g === 'female' ? 1 : g === 'unisex' ? 0.8 : 0;
    else if (a.gender === 'male') gf = g === 'male' ? 1 : g === 'unisex' ? 0.8 : 0;
    else if (a.gender === 'unisex') gf = g === 'unisex' ? 1 : 0.85;
    if (!gf) return null;

    var fams = famsOf(p), sel = a.fam || [], famPts = 0;
    sel.forEach(function (k) { if (fams[k]) { famPts += Math.min(1, 0.6 + fams[k] * 0.2); why.push(FAMILIES[k].label); } });
    var famScore = sel.length ? famPts / sel.length : 0.6;

    var occ = low(p.o), occScore = 1;
    if (a.occ && a.occ !== 'any') {
      occScore = OCCASIONS[a.occ].words.some(function (w) { return occ.indexOf(w) > -1; }) ? 1 : 0.25;
      if (occScore === 1) why.push(OCCASIONS[a.occ].label);
    }
    var seasons = String(p.s || ''), seaScore = 1;
    if (a.season && a.season !== 'any') {
      seaScore = seasons.indexOf(a.season) > -1 ? 1 : 0.2;
      if (seaScore === 1) why.push(a.season);
    } else if (seasons.split(',').filter(Boolean).length >= 4) why.push('Ganzjährig');

    var budScore = 1, price = p.cp || p.p;
    if (a.budget && a.budget !== 'any') {
      var r = a.budget.split('-').map(Number);
      budScore = price >= r[0] && price <= r[1] ? 1 : (price >= r[0] * 0.8 && price <= r[1] * 1.2 ? 0.45 : 0);
    }
    var total = (famScore * 50 + occScore * 20 + seaScore * 15 + budScore * 15) * gf;
    return { p: p, s: total, why: why.slice(0, 3) };
  }

  function card(r, i) {
    var p = r.p, pct = Math.max(55, Math.min(99, Math.round(r.s)));
    var sale = p.c > p.cp ? Math.round((p.c - p.cp) / p.c * 100) : 0;
    return '<article class="mc mq-card" style="animation-delay:' + (i * 60) + 'ms">' +
      '<a class="mc__media" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
      (p.i ? '<img class="mc__img" src="' + esc(p.i) + '" alt="" loading="lazy">' : '') +
      '<span class="mc__badges"><span class="mc__badge mq-match">' + pct + ' % Match</span>' + (sale ? '<span class="mc__badge mc__badge--sale">−' + sale + ' %</span>' : '') + '</span></a>' +
      '<div class="mc__body">' + (p.v ? '<p class="mc__vendor">' + esc(p.v) + '</p>' : '') +
      '<h3 class="mc__title"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' +
      '<p class="mc__price">' + (p.pv ? '<span class="mc__from">ab</span> ' : '') + '<b>' + fmt(p.cp || p.p) + '</b>' + (sale ? ' <s>' + fmt(p.c) + '</s>' : '') + '</p>' +
      (r.why.length ? '<p class="mq-why">' + r.why.map(esc).join(' · ') + '</p>' : '') +
      (p.k ? '<p class="mq-notes"><b>Kopfnote:</b> ' + esc(p.k.split(',').slice(0, 3).join(', ')) + '</p>' : '') +
      '</div></article>';
  }

  function init(root) {
    if (root.dataset.mqReady) return;
    root.dataset.mqReady = '1';
    var stages = {};
    root.querySelectorAll('[data-mq-stage]').forEach(function (s) { stages[s.dataset.mqStage] = s; });
    var answers = {}, step = 0, data = null, dataPromise = null, ranked = [], shown = 0;

    function show(name) {
      Object.keys(stages).forEach(function (k) { stages[k].hidden = k !== name; });
      var top = root.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mh-height'), 10) || 0) - 8;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function load() {
      if (dataPromise) return dataPromise;
      var base = root.dataset.src + (root.dataset.src.indexOf('?') > -1 ? '&' : '?') + 'view=quiz-data';
      var all = [];
      var page = function (n) {
        return fetch(base + '&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.text(); })
          .then(function (t) {
            var d = JSON.parse(t);
            all = all.concat(d.products || []);
            if (d.page < d.pages && n < 6) return page(n + 1);
            return all;
          });
      };
      dataPromise = page(1).then(function (list) { data = list; return list; });
      return dataPromise;
    }

    function renderQuestion() {
      var q = QUESTIONS[step];
      root.querySelector('[data-mq-count]').textContent = 'Frage ' + (step + 1) + ' von ' + QUESTIONS.length;
      root.querySelector('[data-mq-bar]').style.width = ((step + 1) / QUESTIONS.length * 100) + '%';
      root.querySelector('[data-mq-back]').style.visibility = step === 0 ? 'hidden' : 'visible';
      var sel = answers[q.id];
      var html = '<div class="mq-qhead"><h2 class="mq-qtitle">' + esc(q.title) + '</h2>' + (q.sub ? '<p class="mq-qsub">' + esc(q.sub) + '</p>' : '') + '</div>' +
        '<div class="mq-opts mq-opts--' + q.options.length + (q.options[0].sw ? ' has-sw' : '') + '">' +
        q.options.map(function (o) {
          var on = q.type === 'multi' ? (sel || []).indexOf(o.v) > -1 : sel === o.v;
          return '<button type="button" class="mq-opt" data-v="' + esc(o.v) + '" aria-pressed="' + on + '">' +
            (o.sw ? '<span class="mq-opt__sw" style="background:' + o.sw + '"></span>' : '') +
            '<span class="mq-opt__txt"><b>' + esc(o.l) + '</b>' + (o.d ? '<small>' + esc(o.d) + '</small>' : '') + '</span>' +
            '<span class="mq-opt__check" aria-hidden="true"></span></button>';
        }).join('') + '</div>' +
        (q.type === 'multi' ? '<div class="mq-next"><button type="button" class="mq-btn" data-mq-next' + ((sel || []).length ? '' : ' disabled') + '>Weiter →</button></div>' : '');
      var box = root.querySelector('[data-mq-question]');
      box.innerHTML = html;
      box.classList.remove('is-in'); void box.offsetWidth; box.classList.add('is-in');
    }

    function next() {
      if (step < QUESTIONS.length - 1) { step++; renderQuestion(); return; }
      finish();
    }

    function finish() {
      show('loading');
      var txt = root.querySelector('[data-mq-loading-text]');
      var t0 = Date.now();
      load().then(function (list) {
        if (!list.length) throw new Error('empty');
        txt.textContent = 'Wir gleichen deine Antworten mit ' + list.length + ' Düften ab …';
        ranked = list.map(function (p) { return score(p, answers); }).filter(Boolean)
          .sort(function (a, b) { return b.s - a.s; });
        var wait = Math.max(0, 1400 - (Date.now() - t0));
        setTimeout(renderResult, wait);
      }).catch(function () {
        dataPromise = null;
        txt.textContent = 'Die Düfte konnten gerade nicht geladen werden. Bitte versuche es gleich noch einmal.';
        var sp = root.querySelector('.mq-spinner');
        if (sp) sp.hidden = true;
        var box = root.querySelector('.mq-loading');
        if (!promo(box)) return;
        if (!box.querySelector('[data-mq-retry]')) box.insertAdjacentHTML('beforeend', '<button type="button" class="mq-restart" data-mq-retry>↺ Nochmal versuchen</button>');
      });
    }

    function renderResult() {
      var fams = answers.fam || [];
      var profile = fams.map(function (k) { return FAMILIES[k].label; });
      root.querySelector('[data-mq-profile]').textContent = profile.length ? 'Dein Duftprofil: ' + profile.join(' · ') : 'Deine besten Treffer';
      root.querySelector('[data-mq-profile-text]').textContent = fams.length ? FAMILIES[fams[0]].text : '';
      var chips = [];
      var g = QUESTIONS[0].options.filter(function (o) { return o.v === answers.gender; })[0];
      if (g) chips.push(g.l);
      if (answers.occ) chips.push(OCCASIONS[answers.occ].label);
      if (answers.season) chips.push(answers.season === 'any' ? 'Ganzjährig' : answers.season);
      var b = QUESTIONS[4].options.filter(function (o) { return o.v === answers.budget; })[0];
      if (b) chips.push(b.l);
      root.querySelector('[data-mq-chips]').innerHTML = chips.map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('');
      shown = 0;
      root.querySelector('[data-mq-results]').innerHTML = '';
      more(6);
      show('result');
    }

    function promo(box) {
      var tpl = root.querySelector('template[data-mq-promo]');
      if (!tpl || !box || box.querySelector('.mq-promo')) return !!tpl;
      box.appendChild(tpl.content.cloneNode(true));
      return true;
    }

    function more(n) {
      var grid = root.querySelector('[data-mq-results]');
      var slice = ranked.slice(shown, shown + n);
      grid.insertAdjacentHTML('beforeend', slice.map(function (r, i) { return card(r, i); }).join(''));
      shown += slice.length;
      if (!ranked.length) { grid.innerHTML = '<p class="mq-empty">Für diese Kombination haben wir gerade keinen Treffer. Probier eine andere Duftrichtung oder ein anderes Budget.</p>'; promo(grid); }
      root.querySelector('[data-mq-more]').hidden = shown >= Math.min(ranked.length, 18);
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mq-start]')) { step = 0; answers = {}; renderQuestion(); show('quiz'); load(); return; }
      if (e.target.closest('[data-mq-back]')) { if (step > 0) { step--; renderQuestion(); } return; }
      if (e.target.closest('[data-mq-next]')) { next(); return; }
      if (e.target.closest('[data-mq-retry]')) {
        var lb = root.querySelector('.mq-loading');
        lb.querySelectorAll('.mq-promo, [data-mq-retry]').forEach(function (n) { n.remove(); });
        var sp = lb.querySelector('.mq-spinner'); if (sp) sp.hidden = false;
        root.querySelector('[data-mq-loading-text]').textContent = 'Wir gleichen deine Antworten mit unseren Düften ab …';
        finish(); return;
      }
      if (e.target.closest('[data-mq-more]')) { more(6); return; }
      if (e.target.closest('[data-mq-restart]')) { step = 0; answers = {}; renderQuestion(); show('quiz'); return; }
      var opt = e.target.closest('.mq-opt');
      if (!opt) return;
      var q = QUESTIONS[step], v = opt.dataset.v;
      if (q.type === 'multi') {
        var arr = (answers[q.id] || []).slice(), i = arr.indexOf(v);
        if (i > -1) arr.splice(i, 1); else if (arr.length < q.max) arr.push(v); else { arr.shift(); arr.push(v); }
        answers[q.id] = arr;
        renderQuestion();
      } else {
        answers[q.id] = v;
        opt.setAttribute('aria-pressed', 'true');
        setTimeout(next, 220);
      }
    });
  }

  function boot() { document.querySelectorAll('[data-mq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
